import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyIssueRoute: InvariantJiraRoute = {
	name: 'legacy-issue',
	path: '/browse/:issueKey(\\w+-\\d+)(.*)',
	query: ['jql!=(.+)', 'filter!=(.+)'],
};
